export const SCENARIOS_REQUEST = 'SCENARIOS_REQUEST';
export const SCENARIOS_SUCCESS = 'SCENARIOS_SUCCESS';

export const ORGANIZATIONS_REQUEST = 'SCENARIOS_ORGANIZATIONS_REQUEST';
export const ORGANIZATIONS_SUCCESS = 'SCENARIOS_ORGANIZATIONS_SUCCESS';

export const USERS_SUCCESS = 'SCENARIOS_USERS_SUCCESS';

export const UPDATE_SCENARIOS_REQUEST = 'UPDATE_SCENARIOS_REQUEST';
export const UPDATE_SCENARIOS_SUCCESS = 'UPDATE_SCENARIOS_SUCCESS';

export const BULK_ACTIVATE_SCENARIOS_REQUEST = 'SCENARIOS_BULK_ACTIVATE_SCENARIOS_REQUEST';
export const BULK_ACTIVATE_SCENARIOS_SUCCESS = 'SCENARIOS_BULK_ACTIVATE_SCENARIOS_SUCCESS';

export const BULK_DELETE_OR_ARCHIVE_SCENARIOS_REQUEST = 'SCENARIOS_BULK_DELETE_OR_ARCHIVE_SCENARIOS_REQUEST';
export const BULK_DELETE_OR_ARCHIVE_SCENARIOS_SUCCESS = 'SCENARIOS_BULK_DELETE_OR_ARCHIVE_SCENARIOS_SUCCESS';

export const CACHE_SCENARIOS = 'CACHE_SCENARIOS';

export const DISPOSE_SCENARIOS_STORES = 'DISPOSE_SCENARIOS_STORES';

export const EVALUATION_DRAFT_MODEL_TYPES = ['gpt-4o', 'gpt-4o-mini'];
